import React from 'react'
import { connect } from 'react-redux'
import { Select } from '@blueprintjs/select'
import { Button, MenuItem } from '@blueprintjs/core'
import * as filterModules from 'src/store/modules/cmdb/filters'

const filterRenderer = (filter, { handleClick, modifiers }) => {
    return (
        <MenuItem
            active={modifiers.active}
            key={filter.id}
            text={filter.name}
            onClick={handleClick}
        />
    )
}

class DeviceFilterSelect extends React.Component {
    render() {
        const { filters, selected, handleFilterSelect } = this.props

        return (
            <Select
                items={filters}
                itemRenderer={filterRenderer}
                onItemSelect={handleFilterSelect}
                filterable={false}
            >
                <Button>{selected.name}</Button>
            </Select>
        )
    }
}

export default connect(
    (state) => ({
        filters: filterModules.getFilters(state),
        selected: filterModules.getFilterById(
            state,
            state.cmdb.filters.selected
        ),
    }),
    {
        handleFilterSelect: filterModules.selectFilter,
    }
)(DeviceFilterSelect)
